<latch-loading [isActive]="(auth.isLoading$ | async) || false">
  <router-outlet></router-outlet>
</latch-loading>
